import { sortBy } from 'lodash'

export default function registerPlaceholderSelect (CKEDITOR) {
  CKEDITOR.plugins.add('placeholder_select',
    {
      requires: ['richcombo'],
      init: function (editor) {
      //  array of placeholders to choose from that'll be inserted into the editor
        let placeholderGroups = []

        // init the default config - empty placeholders
        const defaultConfig = {
          format: '[[%placeholder%]]',
          placeholderGroups: []
        }

        // merge defaults with the passed in items
        // eslint-disable-next-line no-undef
        const config = CKEDITOR.tools.extend(defaultConfig, editor.config.placeholder_select || {}, true)

        placeholderGroups = config.placeholderGroups.map(x => {
          const placeholders = sortBy(x.placeholders, 'name')
          return {
            ...x,
            placeholders: placeholders.map(p => {
              return { ...p, value: config.format.replace('%placeholder%', p.id) }
            })
          }
        })

        placeholderGroups.forEach(x => {
        // add the menu to the editor
          editor.ui.addRichCombo(`placeholder_select${x.name}`,
            {
              label: x.name,
              title: x.name,
              voiceLabel: x.name,
              className: 'cke_format',
              multiSelect: false,
              panel:
            {
              css: [editor.config.contentsCss, CKEDITOR.skin.getPath('editor')],
              voiceLabel: editor.lang.panelVoiceLabel
            },
              init: function () {
                this.startGroup(x.name)
                x.placeholders.forEach(p => {
                  this.add(p.value, p.name, p.name)
                })
              },

              onClick: function (value) {
                editor.focus()
                editor.fire('saveSnapshot')
                editor.insertHtml(value)
                editor.fire('saveSnapshot')
              }
            })
        })
      }
    })
}
